import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text, Flex, Link, Icon } from "@chakra-ui/react";
import { format } from "date-fns";
import { useParams, useNavigate } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import { getPriceRange } from "../../../shared-utils/utils";
import { appendTrackingParams } from "../../../shared-utils/trackingUtils";
import { ZILLOUT_WEB_BASE_URL } from "../../../config/urls";
const SubEventCard = ({ event_id, subEvent, isBookingAllowed, isTableBookingEnabled, hasBufferTimeEnabled, bufferTimeMinutes, whatsHappeningEvents, openSelectPaxAndTimeModal, appContext = "customer", }) => {
    var _a;
    const { bookingType } = useParams();
    const navigate = useNavigate();
    const hasHappenings = (_a = whatsHappeningEvents === null || whatsHappeningEvents === void 0 ? void 0 : whatsHappeningEvents.some((event) => {
        var _a;
        return (_a = event.placements) === null || _a === void 0 ? void 0 : _a.some((placement) => placement.levelType === "SUB_EVENT" &&
            placement.levelRefId === subEvent.id);
    })) !== null && _a !== void 0 ? _a : false;
    const openRoute = (route) => {
        if (appContext === "experience") {
            navigate(-1);
            setTimeout(() => {
                window.open(appendTrackingParams(`${ZILLOUT_WEB_BASE_URL}${route}`), "_self");
            }, 10);
        }
        else {
            navigate(route);
        }
    };
    const hasAvailableSlots = () => {
        // If no slots exist, return false
        if (!subEvent.slots || subEvent.slots.length === 0) {
            return false;
        }
        const now = new Date();
        const bufferTime = bufferTimeMinutes || 0;
        const minimumBookableTime = new Date(now.getTime() + bufferTime * 60 * 1000);
        // Check if any slot has bookable time remaining
        const result = subEvent.slots.some((slot) => {
            const slotStartTime = new Date(slot.start_time);
            const slotEndTime = new Date(slot.end_time);
            if (now > slotEndTime) {
                return false;
            }
            if (bufferTime > 0) {
                const isBookable = minimumBookableTime < slotEndTime;
                return isBookable;
            }
            return true;
        });
        return result;
    };
    const priceRange = getPriceRange(subEvent);
    const showBookNow = isBookingAllowed && hasAvailableSlots();
    return (_jsxs(Box, { bg: "#232222", borderRadius: "2xl", px: 6, py: 4, mb: 4, color: "white", boxShadow: "md", border: "1px solid #353535", maxW: "400px", w: "100%", children: [_jsx(Text, { fontWeight: "bold", fontSize: "xs", mb: 2, children: subEvent.name }), _jsxs(Flex, { align: "center", fontSize: "10px", fontWeight: 400, mb: 2, children: [_jsxs(Text, { children: [format(new Date(subEvent.start_time), "hh:mm a"), " -", " ", format(new Date(subEvent.end_time), "hh:mm a")] }), _jsx(Box, { mx: 2, w: "3px", h: "3px", borderRadius: "full", bg: "white" }), _jsx(Text, { children: format(new Date(subEvent.start_time), "dd EEE, MMM") })] }), subEvent.description && (_jsx(Text, { color: "#FFFFFF80", fontSize: "10px", mb: 2, children: subEvent.description })), hasHappenings && (_jsx(Text, { fontSize: "xs", color: "#A383FF", cursor: "pointer", onClick: () => openRoute(`/sub-event/${subEvent.id}/${encodeURIComponent(subEvent.name)}/whats-happening`), mb: 2, children: "EXPLORE WHAT'S HAPPENING \u2192" })), _jsx(Box, { borderTop: "1px solid #353535", my: 3 }), _jsxs(Flex, { align: "center", justify: "space-between", children: [_jsx(Text, { fontWeight: "bold", fontSize: "xs", children: priceRange.priceText }), showBookNow ? (_jsxs(Link, { onClick: () => {
                            if (openSelectPaxAndTimeModal &&
                                hasBufferTimeEnabled &&
                                !isTableBookingEnabled) {
                                openSelectPaxAndTimeModal(subEvent.id);
                            }
                            else if (openSelectPaxAndTimeModal &&
                                isTableBookingEnabled !== false) {
                                openSelectPaxAndTimeModal(subEvent.id);
                            }
                            else if (openSelectPaxAndTimeModal && !isTableBookingEnabled) {
                                openRoute(`/event/booking/${event_id}?sub_event=${subEvent.name}_${subEvent.id}`);
                            }
                            else {
                                bookingType === "walkin"
                                    ? openRoute(`/event/booking/${event_id}/walkin?sub_event=${subEvent.name}_${subEvent.id}`)
                                    : openRoute(`/event/booking/${event_id}?sub_event=${subEvent.name}_${subEvent.id}`);
                            }
                        }, display: "flex", alignItems: "center", gap: 1, fontSize: "xs", fontWeight: 700, color: "#A383FF", textDecoration: "none", children: ["Book Now", _jsx(Icon, { as: MdKeyboardArrowRight, w: 4, h: 4 })] })) : null] })] }));
};
export default SubEventCard;
